import React, { useEffect, useState } from 'react';
import {
  Button,
  Input,
  DatePicker,
  Table,
  Select,
  Balloon,
  Form,
  Radio,
  Tab,
} from '@alifd/next';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { CanvasService } from '@/service';
import LzMsg from '@/components/common/LzMsg';
import LzDialog from '@/components/common/LzDialog';
import DataExport from '@/components/DataExport';
import LzPagination from '@/components/common/LzPagination';
import NodeList from './components/NodeList';
import styles from './index.module.scss';
import DataGoodsExport from '@/components/DataGoodsExport';
import PageUtils from '../utils';
import { appHistory } from '@ice/stark-app';

export default ({ datasource }) => {
  const { Tooltip } = Balloon;
  const Option = Select.Option;
  const RadioGroup = Radio.Group;
  const history = useHistory();
  const FormItem = Form.Item;
  // 当前Tab
  const [currentKey, setCurrentKey] = useState(1);
  // 任务类型  是否是单次
  const [isSingle, setIsSingle] = useState(true);
  // 商品数量导出弹窗
  const [goodsExport, setGoodsExport] = useState(false);
  // 页面loading
  const [loading, setLoading] = useState(false);
  const [crowdData, setCrowdData] = useState([]);
  // 活动名称
  const [compagainName, setCompagainName] = useState('');
  // 分页
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  //  选中
  const [chooseNum, setChooseNum] = useState(0);


  // 被选的报表的taskInstId
  const [chartKeys, setChartKeys] = useState([]);
  // 节点报表activityId
  const [activityId, setActivityId] = useState(1);
  const [taskInstIds, setTaskInstIds] = useState([]) // 当前选中项的策略id
  // 列表参数
  const [formParams, setFormParams] = useState({
    activityId: '',
    taskName: '',
    startTime: '',
    endTime: '',
    cycleNum: '',
    reportTime: 1, // 数据时间口径
    // dimension: 2, // 数据口径
    canvasTaskType: 4, // 营销类型
  });
  // 选中的营销类型
  const [selectedType, setSelectedType] = useState(4);
  // 是否存在活动id
  const [isAcitivityId, setIsActivityId] = useState(true);
  // 翻页
  const handlePageSizeChange = async (pages = {}) => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      searchList({
        ...formParams,
        pageSize: pages.pageSize,
        pageNo: pages.pageNo,
        // taskName:formParams.taskName,
        // cycleNum:formParams.cycleNum,
        // startTime:formParams.startTime,
        // endTime:formParams.endTime
      });
    } catch (e) {
      // LzMsg.error(e.message);
    }
  };

  // 循环次数
  const [cycleTimes, setCycleTimes] = useState();

  const [checkedKeys, setCheckedKeys] = useState('');

  const onSelectMission = (args, record) => {
    setChartKeys(args);
    setCheckedKeys(args);
    setChooseNum(args.length);
  };

  // const rowSelection = {
  //   onChange: onSelectMission,
  //   selectedRowKeys: checkedKeys
  // };

  // tab标签列表
  const tabList = [
    {
      label: '1日',
      value: 1,
    },
    {
      label: '3日',
      value: 3,
    },
    {
      label: '5日',
      value: 5,
    },
    {
      label: '7日',
      value: 7,
    },
  ];

  // tab标签列表
  const dataTabList = [
    {
      label: '汇总',
      value: 2,
    },
    {
      label: '触达',
      value: 0,
    },
    {
      label: '点击',
      value: 1,
    },
  ];
  // 导出是否显示
  const [dataExportVisible, setDataExportVisible] = useState(false);
  // 子组件关闭
  const onExportVisible = () => {
    setDataExportVisible(false);
  };

  // 子组件关闭
  const onGoodsExportVisible = () => {
    setGoodsExport(false);
  };

  // 查询按钮
  const fetchData = (v) => {
    // 走接口
    if (isAcitivityId) {
      searchList({
        ...formParams,
        taskName: v.strategyName ? v.strategyName : '',
        startTime:
          v.strategyTime && v.strategyTime.length !== 0
            ? moment(v.strategyTime[0]._d).format('x')
            : '',
        endTime:
          v.strategyTime && v.strategyTime.length !== 0
            ? moment(v.strategyTime[1]._d).endOf('day').format('x')
            : '',
        cycleNum: v.strategyType ? v.strategyType : '',
        canvasTaskType: v.canvasTaskType ? v.canvasTaskType : 4,
        pageNo: 1,
        pageSize: pageInfo.pageSize,
      });
    }
    // 暂存参数
    setFormParams({
      ...formParams,
      taskName: v.strategyName,
      startTime:
        v.strategyTime && v.strategyTime.length !== 0
          ? moment(v.strategyTime[0]._d).format('x')
          : '',
      endTime:
        v.strategyTime && v.strategyTime.length !== 0
          ? moment(v.strategyTime[1]._d).endOf('day').format('x')
          : '',
      canvasTaskType: v.canvasTaskType ? v.canvasTaskType : 4,
      cycleNum: v.strategyType ? v.strategyType : '',
    });
    setNodeFormParams({
      ...nodeFormParams,
      taskName: v.strategyName,
      startTime:
        v.strategyTime && v.strategyTime.length !== 0
          ? moment(v.strategyTime[0]._d).format('x')
          : '',
      endTime:
        v.strategyTime && v.strategyTime.length !== 0
          ? moment(v.strategyTime[1]._d).endOf('day').format('x')
          : '',
      canvasTaskType: v.canvasTaskType ? v.canvasTaskType : 4,
      cycleIndex: v.strategyType ? v.strategyType : '',
    });
  };

  // 列表接口
  const searchList = (params) => {
    setLoading(true);
    CanvasService.getChartList(params)
      .then((res) => {
        const temp = res.data;
        temp.forEach((item, index) => {
          item.roi = Number(item.roi).toFixed(2);
          item.realPeople = Number(item.realPeople).toFixed(0);
          item.payPins = Number(item.payPins).toFixed(0);
          item.ordPins = Number(item.ordPins).toFixed(0);
          item.interester = Number(item.interester).toFixed(0);
          item.payAmount = Number(item.payAmount).toFixed(2);
          item.ordAmount = Number(item.ordAmount).toFixed(2);
        });
        // 赋值
        setCrowdData(temp);
        // 设置翻页
        setPageInfo({
          ...pageInfo,
          total: res.page.total,
          pageNo: res.page.pageNo,
          pageSize: res.page.pageSize,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // key
  const [paramKey, setParamKey] = useState();
  // 节点列表参数campaignId
  const [nodeCampaignId, setNodeCampaignId] = useState();
  // 列表参数
  const [nodeFormParams, setNodeFormParams] = useState({
    campaignId: '',
    taskName: '',
    startTime: '',
    endTime: '',
    cycleIndex: '',
    canvasTaskType: 4, // 营销类型
    pre: datasource.location.state.data.campaignState,
    pageSize: '',
    pageNo: '',
  });
  //  优惠促销类别所需 taskInstId
  const [prompotionList, setPrompotionList] = useState([]);
  // 短信类别 所需 takInstId
  const [smsList, setSmsList] = useState([]);
  useEffect(() => {
    // 首先获取活动taskId
    let key;
    if (
      datasource.location.state &&
      datasource.location.state.data.processKey.indexOf('sid-') !== -1
    ) {
      key = datasource.location.state.data.processKey;

      setParamKey(key);
    } else {
      key = `${datasource.location.state.data.processKey}`;
      setParamKey(key);
    }
    const taskType = datasource.location.state.data.taskType;
    // if(datasource.location.state?.data?.canvasProcessDetail?.processDesignModel?.childShapes) {
    //   let arr = datasource.location.state?.data?.canvasProcessDetail?.processDesignModel?.childShapes;
    //   let typeArr: any[] = [];
    //   arr.forEach(item => {
    //     typeArr.push(item.resourceType)
    //   });
    //   // 只有仅存在优惠促销时传5，其他情况传4
    //   if(typeArr.includes('MARKETING_MSG_BOX') && !typeArr.includes('MARKETING_SMS')) {
    //     taskType = 5
    //   } else {
    //     taskType = 4
    //   }
    // }
    setSelectedType(taskType);
    // 判断是不是单次任务
    if (
      datasource.location.state &&
      +datasource.location.state.data.executionPlan.type === 2
    ) {
      setIsSingle(false);
    }
    // 设置任务名
    setCompagainName(datasource.location.state.data.campaignName);
    // 先根据processKey拿到任务id，再通过id查询报表
    // CanvasService.getCompagainId({ processKey: key })
    //   .then((res) => {
        searchList({
          pageNo: 1,
          pageSize: pageInfo.pageSize,
          // dimension: 2,
          reportTime: 1,
          // activityId: res.data,
          activityId: datasource.location.state.data.id,
          canvasTaskType: taskType,
        });
        // setActivityId(res.data);
        // 赋值新id
        setFormParams({
          ...formParams,
          activityId: datasource.location.state.data.id,
          canvasTaskType: taskType,
        });
      // })
      // .catch((e) => {
      //   setIsActivityId(false);
      //   console.log(e);
      // });
    // 赋值节点报表参数
    setNodeFormParams({
      ...nodeFormParams,
      campaignId: datasource.location.state.data.id,
      canvasTaskType: taskType,
    });
  }, []);
  useEffect(() => {
    if (paramKey) {
      setCycleTimes('');
      setFormParams({
        ...formParams,
        cycleNum: '',
        taskName: '',
        startTime: '',
        endTime: '',
      });
      if (isAcitivityId) {
        searchList({
          ...formParams,
          pageNo: pageInfo.pageNo,
          pageSize: pageInfo.pageSize,
          cycleNum: '',
          taskName: '',
          startTime: '',
          endTime: '',
        });
      }
    }
  }, [currentKey]);

  return (
    <div style={{ marginBottom: '10px' }}>
      <div className={styles.bodyBox}>
        <Form
          inline
          style={{
            marginBottom: '20px',
            paddingTop: '25px',
            paddingLeft: '20px',
            paddingRight: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              marginTop: '10px',
              marginBottom: '10px',
              justifyContent: 'space-between',
            }}
          >
            <Form.Item className={styles.labelWidth}>
              <span className={styles.mr15}>执行时间：</span>
              <DatePicker.RangePicker
                placeholder={['开始时间', '结束时间']}
                name="strategyTime"
                hasClear={false}
                style={{ width: '80%' }}
              />
            </Form.Item>
            <Form.Item className={styles.labelWidth}>
              <span className={styles.mr15}>节点名称：</span>
              <Input
                name="strategyName"
                placeholder="请输入节点名称"
                size="small"
                style={{ width: '80%' }}
              />
            </Form.Item>
            <Form.Item className={styles.labelWidth} style={{ textAlign: 'right' }}>
              <Form.Submit
                type="primary"
                onClick={(v) => {
                  fetchData(v);
                }}
                style={{ width: '88px' }}
              >
                查询
              </Form.Submit>
              <Form.Reset
                type="normal"
                onClick={() => {
                  setCycleTimes('');
                  setFormParams({
                    ...formParams,
                    cycleNum: '',
                    taskName: '',
                    startTime: '',
                    endTime: '',
                  });
                  if (isAcitivityId) {
                    searchList({
                      ...formParams,
                      pageNo: pageInfo.pageNo,
                      pageSize: pageInfo.pageSize,
                      cycleNum: '',
                      taskName: '',
                      startTime: '',
                      endTime: '',
                    });
                  }
                  setNodeFormParams({
                    ...nodeFormParams,
                    taskName: '',
                    startTime: '',
                    endTime: '',
                    cycleIndex: '',
                    pageSize: 10,
                    pageNo: 1,
                  });
                }}
                style={{ width: '88px', marginLeft: '10px' }}
              >
                重置
              </Form.Reset>
            </Form.Item>
            {/* <Form.Item className={styles.labelWidth} style={{ flex: 1 }}>
              <span className={styles.mr15}>循环次数：</span>
              <Input
                name="strategyType"
                placeholder="请输入循环次数"
                size="small"
                value={cycleTimes}
                style={{ width: '80%' }}
                onChange={(v) => {
                  setCycleTimes(v.replace(/\D/g, ''));
                }}
              />
            </Form.Item> */}
          </div>
          <div style={{ marginBottom: '20px', display: 'flex' }}>
            {/* <Form.Item className={styles.labelWidth} style={{ flex: 1 }}>
              <span className={styles.mr15}>营销类型：</span>
              <Select
                name="canvasTaskType"
                style={{ width: '80%' }}
                value={selectedType}
                onChange={(taskType) => {
                  setSelectedType(taskType);
                }}
              >
                {
                    PageUtils.nodeType.map((item) => {
                        return (
                            <Option value={item.value} key={item.value}>
                                {item.label}
                            </Option>
                        );
                    })
                }
              </Select>
            </Form.Item>
            <Form.Item style={{ flex: 1 }}>
              <div style={{ width: '80%' }} />
            </Form.Item>
            <div
              style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}
            >
              <Form.Submit
                type="primary"
                onClick={(v) => {
                  fetchData(v);
                }}
                style={{ width: '88px' }}
              >
                查询
              </Form.Submit>
              <Form.Reset
                type="normal"
                onClick={() => {
                  setCycleTimes('');
                  setFormParams({
                    ...formParams,
                    cycleNum: '',
                    taskName: '',
                    startTime: '',
                    endTime: '',
                  });
                  if (isAcitivityId) {
                    searchList({
                      ...formParams,
                      pageNo: pageInfo.pageNo,
                      pageSize: pageInfo.pageSize,
                      cycleNum: '',
                      taskName: '',
                      startTime: '',
                      endTime: '',
                    });
                  }
                  setNodeFormParams({
                    ...nodeFormParams,
                    taskName: '',
                    startTime: '',
                    endTime: '',
                    cycleIndex: '',
                    pageSize: 10,
                    pageNo: 1,
                  });
                }}
                style={{ width: '88px', marginLeft: '10px' }}
              >
                重置
              </Form.Reset>
            </div> */}
          </div>
        </Form>
        <div className="model-tab" style={{ margin: '40px 20px 20px 20px' }}>
          <div className="second-level">
            <Tab
              shape="wrapped"
              activeKey={currentKey || 1}
              onChange={(v) => {
                setCurrentKey(v);
              }}
            >
              <Tab.Item title="节点报表" key={1}>
                {nodeFormParams.campaignId && Number(currentKey) === 1 && (
                  <NodeList formParams={nodeFormParams} />
                )}
              </Tab.Item>
              <Tab.Item title="效果报表" key={2}>
                {Number(currentKey) === 2 && (
                  <div>
                    <div className={styles.tabBox}>
                      {/* <div
                        className={styles.data_dem}
                        style={{
                          display: 'flex',
                          position: 'relative',
                          marginRight: '100px',
                        }}
                      >
                        <div style={{ height: '28px', lineHeight: '28px' }}>
                          数据口径：
                        </div>
                        <Radio.Group
                          shape="button"
                          dataSource={dataTabList}
                          value={formParams.dimension}
                          onChange={(v) => {
                            setFormParams({ ...formParams, dimension: v });
                            if (isAcitivityId) {
                              searchList({
                                ...formParams,
                                pageNo: 1,
                                pageSize: pageInfo.pageSize,
                                dimension: v,
                              });
                            }
                          }}
                          style={{ marginRight: '50px' }}
                        />
                        <Tooltip
                          id="aria-tooltip"
                          align="t"
                          trigger={
                            <div
                              style={{
                                fontSize: '14px',
                                color: '5584FF',
                                cursor: 'pointer',
                                position: 'absolute',
                                top: '6px',
                                right: '20px',
                              }}
                              className="iconfont icon-icon4-33"
                            />
                          }
                        >
                          触达: 代表仅触达没有点击的人群
                          <br />
                          点击: 代表仅点击的人群
                        </Tooltip>
                      </div> */}
                      <div
                        className={styles.time_dem}
                        style={{ display: 'flex', position: 'relative' }}
                      >
                        <div style={{ height: '28px', lineHeight: '28px' }}>
                          数据时间口径：
                        </div>
                        <Radio.Group
                          shape="button"
                          dataSource={tabList}
                          value={formParams.reportTime}
                          onChange={(v) => {
                            // 改暂存参数
                            setFormParams({ ...formParams, reportTime: v });
                            // 调接口
                            if (isAcitivityId) {
                              searchList({
                                ...formParams,
                                pageNo: 1,
                                pageSize: pageInfo.pageSize,
                                reportTime: v,
                              });
                            }
                          }}
                          style={{ display: 'flex', alignItems: 'center' }}
                        />
                        <Tooltip
                          id="aria-tooltip"
                          align="t"
                          trigger={
                            <div
                              style={{
                                fontSize: '14px',
                                color: '5584FF',
                                cursor: 'pointer',
                                top: '4px',
                                right: '-20px',
                                position: 'absolute',
                              }}
                              className="iconfont icon-icon4-33"
                            />
                          }
                        >
                          显示短信发送后，发送时间起，1日、3日、5日、7日的效果数据
                        </Tooltip>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '15px',
                      }}
                    >
                      <div style={{ height: '28px', lineHeight: '28px' }}>
                        已选择
                        <span
                          style={{
                            color: '#FF3333',
                            paddingLeft: '5px',
                            paddingRight: '5px',
                          }}
                        >
                          {chartKeys.length}
                        </span>
                        项
                        <span
                          style={{
                            color: 'rgb(51, 153, 255)',
                            marginLeft: '10px',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setChartKeys([]);
                          }}
                        >
                          清空
                        </span>
                      </div>
                      <div>
                      {/* <Button
                        type="secondary"
                        style={{ marginLeft: '10px', width: '120px', padding: 0 }}
                        className={styles.btn}
                        onClick={() => {
                          if (chartKeys.length === 0) {
                            LzMsg.error('请选择要导出的任务');
                          } else {
                            setGoodsExport(true)
                          }
                        }}
                      >
                        商品数据批量导出
                      </Button> */}
                        <Button
                          type="secondary"
                          style={{
                            marginLeft: '10px',
                            padding: 0,
                            width: '88px',
                          }}
                          className={styles.btn}
                          onClick={() => {
                            if (chartKeys.length === 0) {
                              LzMsg.error('请选择要导出的任务');
                            } else {
                              setDataExportVisible(true);
                            }
                          }}
                        >
                          批量导出
                        </Button>
                      </div>
                    </div>
                    <div>
                      <Table.StickyLock
                        dataSource={crowdData}
                        // fixedHeader maxBodyHeight={(window.screen.height) * 0.6 - 170}
                        loading={loading}
                        rowSelection={{
                          selectedRowKeys: chartKeys,
                          // args 数组的0项是值  1 项是数据对象
                          onChange: (args,records) => {
                            // 改变选中list的值
                            setChartKeys(args);
                            // let tempSmsTaskInstIdList = [...smsList];
                            // let tempPromotionTaskInstIdList = [];
                            // for(let value of args[1]){
                            //   // 短信
                            //   if(value.taskType === 4){
                            //     tempSmsTaskInstIdList.push(value.taskInstId)
                            //   // 优惠促销
                            //   }else if(value.taskType === 5){
                            //     tempPromotionTaskInstIdList.push(value.taskInstId)
                            //   }
                            // }
                            setSmsList(args);
                            setPrompotionList(args);
                            let tempChecked = JSON.parse(JSON.stringify(taskInstIds));
                            records.forEach((item)=>{
                              tempChecked.push(item)
                            });
                            // 对已选商品skuChecked去重
                            let hash = {};
                            let newArray = tempChecked.reduce((item, next)=>{
                              hash[next.taskInstId] ? '' : hash[next.taskInstId] = true && item.push(next);
                              return item;
                            },[]);
                            // 过滤掉未勾选的商品
                            let finalArr = newArray.filter(item => args.indexOf(item.taskInstId) > -1);
                            setTaskInstIds(finalArr);
                          },
                        }}
                        primaryKey="taskInstId"
                        style={{ overflowX: 'auto', width: '100%' }}
                      >
                        <Table.Column
                          align="left"
                          width="200px"
                          title={() => {
                            return (
                              <div>
                                节点名称&nbsp;
                                <Balloon.Tooltip
                                  trigger={
                                    <span
                                      style={{
                                        fontSize: '14px',
                                        marginLeft: '4px',
                                        cursor: 'pointer',
                                      }}
                                      className="iconfont icon-icon4-33"
                                    />
                                  }
                                  align="b"
                                >
                                  只统计营销节点
                                </Balloon.Tooltip>
                              </div>
                            );
                          }}
                          dataIndex="taskName"
                        />
                        {/* <Table.Column
                          align="left"
                          width="100px"
                          title="营销类型"
                          dataIndex="taskType"
                          cell={(value, index, item) =>
                            (
                                <div>{PageUtils.nodeType.find(item => item?.value === +value)?.label ?? '/'}</div>
                            )
                          }
                        />
                        {!isSingle && (
                          <Table.Column
                            align="left"
                            title="循环次数"
                            dataIndex="cycleNum"
                            width="100px"
                          />
                        )} */}
                        <Table.Column
                          align="left"
                          title="执行时间"
                          cell={(value, index, item) => (
                            <div>
                              {moment(Number(item.sendTime)).format(
                                'YYYY-MM-DD HH:mm:ss'
                              )}
                            </div>
                          )}
                          width="150px"
                        />
                        <Table.Column
                          align="left"
                          title="实际投放人数"
                          dataIndex="realPeople"
                          width="100px"
                        />
                        <Table.Column
                          width="100px"
                          title={
                            <div>
                              <span>ROI</span>
                              <Tooltip
                                align="t"
                                trigger={
                                  <span
                                    style={{
                                      fontSize: '14px',
                                      marginLeft: '4px',
                                      cursor: 'pointer',
                                    }}
                                    className="iconfont icon-icon4-33"
                                  />
                                }
                              >
                                ROI=实际发送人群付款总金额/（实际发送短信条数*每条短信成本）
                                <br />
                                短信发送后T+3获取
                              </Tooltip>
                            </div>
                          }
                          align="left"
                          dataIndex="roi"
                          cell={(value, index, item) => (
                            <div>{Number(item.roi).toFixed(2)}</div>
                          )}
                        />
                        <Table.Column
                          width="100px"
                          title={
                            <div>
                              <span>访问人数</span>
                              <Tooltip
                                align="t"
                                trigger={
                                  <span
                                    style={{
                                      fontSize: '14px',
                                      marginLeft: '4px',
                                      cursor: 'pointer',
                                    }}
                                    className="iconfont icon-icon4-33"
                                  />
                                }
                              >
                                对店铺首页和详情页进行访问的人数之和。(由于平台目前开放现状,访客人数不去重)
                              </Tooltip>
                            </div>
                          }
                          align="left"
                          dataIndex="recallUserCnt"
                        />
                        {/* <Table.Column
                          width="100px"
                          title={
                            <div>
                              <span>兴趣人数</span>
                              <Tooltip
                                align="t"
                                trigger={
                                  <span
                                    style={{
                                      fontSize: '14px',
                                      marginLeft: '4px',
                                      cursor: 'pointer',
                                    }}
                                    className="iconfont icon-icon4-33"
                                  />
                                }
                              >
                                对店铺进行收藏，对商品进行加购和收藏的人数之和。(由于平台目前开放现状,访客人数不去重)
                              </Tooltip>
                            </div>
                          }
                          align="left"
                          dataIndex="interester"
                        />
                        <Table.Column
                          width="100px"
                          align="left"
                          title="下单人数"
                          dataIndex="ordPins"
                        />
                        <Table.Column
                          width="100px"
                          align="left"
                          title="下单金额"
                          dataIndex="ordAmount"
                        />
                        <Table.Column
                          width="100px"
                          align="left"
                          title="付款人数"
                          dataIndex="payPins"
                        />
                        <Table.Column
                          width="100px"
                          align="left"
                          title="付款金额"
                          dataIndex="payAmount"
                        /> */}
                        <Table.Column
                          width="100px"
                          align="left"
                          title="成交人数"
                          dataIndex="orderUserCnt"
                        />
                        <Table.Column
                          width="100px"
                          align="left"
                          title="成交金额"
                          dataIndex="orderAmt"
                        />
                        <Table.Column
                          align="left"
                          title="操作"
                          width="160px"
                          lock="right"
                          cell={(value, index, row) => (
                            <div>
                              <Button
                                type="primary"
                                text
                                onClick={() => {
                                    appHistory.push(`../../task/${row.taskInstId}`);
                                }}
                              >
                                数据详情
                              </Button>
                            </div>
                          )}
                        />
                      </Table.StickyLock>
                    </div>
                    <div
                      style={{
                        paddingBottom: '20px',
                      }}
                    >
                      <LzPagination
                        pageInfo={pageInfo}
                        onChange={handlePageSizeChange}
                      />
                    </div>
                  </div>
                )}
              </Tab.Item>
            </Tab>
          </div>
        </div>
        {/* 商品数据导出弹窗 */}
        {
            goodsExport &&
            <LzDialog
              visible={goodsExport}
              footer={false}
              shouldUpdatePosition
              title="数据导出"
              onClose={() => {
                setGoodsExport(false);
              }}
              isFullScreen
              style={{
                width: '1060px',
                minWidth: '900px',
              }}
            >
              <DataGoodsExport onExportVisible={onGoodsExportVisible} taskInstId={taskInstIds} />
            </LzDialog>
        }
        {/* 数据导出弹框 */}
        <LzDialog
          visible={dataExportVisible}
          footer={false}
          shouldUpdatePosition
          title="数据导出"
          onClose={() => {
            setDataExportVisible(false);
          }}
          style={{
            width: '1060px',
            minWidth: '400px',
          }}
        >
          {/*  isPromotion 优惠促销 */}
          <DataExport
            onExportVisible={onExportVisible}
            taskInstId={smsList}
            isPromotion={prompotionList}
          />
        </LzDialog>
        {/* 数据导出弹框结束 */}
      </div>
    </div>
  );
};
